import { types } from 'actions/authentication/types';
import Mobilise from 'api/clients/Mobilise';
import showNotification, { typeNotification } from 'utils/showNotification';

const MobiliseClient = new Mobilise();

export const register = (data) => async (dispatch) => {
    dispatch({ type: types.REGISTRATION_REQUEST, payload: true });

    await MobiliseClient.registerUser(data)
        .then(({ data }) => {
            dispatch({ type: types.REGISTRATION_SUCCESS, payload: true });
            dispatch({ type: types.REGISTRATION_REQUEST, payload: false });
        })
        .catch((err) => {
            dispatch({ type: types.REGISTRATION_REQUEST, payload: false });
            dispatch({ type: types.REGISTRATION_FAILURE, payload: true });

            for (const key in err) {
                for(const i in err[key]) {
                    showNotification(err[key][i], 'error');
                }
            }
        });
};

export const checkIfUserEmailOrPhoneNumberExists = (email, phoneNumber) => async (dispatch) => {
    dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_REQUEST, payload: true });

    await MobiliseClient.validateEmailAndPhoneNumber(email, phoneNumber)
        .then((data) => {
            dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_REQUEST, payload: false });
            dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_FAILURE, payload: false });
            dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_SUCCESS, payload: true });
        })
        .catch((data) => {
            for(const i in data) {
                for(const j in data[i]) {
                    showNotification(data[i][j], 'error');
                }
            }
            dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_REQUEST, payload: false });
            dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_FAILURE, payload: { error: true, data: data } });
        });
};
